import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignTopBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-align-top-bottom, padding"} maskId="square-filled-radius-0-stroke-1-IconLayoutAlignTopBottom"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 16V17H17V16H7ZM7 8H17V7H7V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutAlignTopBottom;
